export default __webpack_public_path__ + "media/images/brighteon-social/Icon-HashTags-Gray-f7c6d96122a78185957155a239bdef01.svg";